import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=299ed6a4&scoped=true&"
import script from "./pay.vue?vue&type=script&lang=ts&"
export * from "./pay.vue?vue&type=script&lang=ts&"
import style0 from "./pay.vue?vue&type=style&index=0&id=299ed6a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299ed6a4",
  null
  
)

export default component.exports